import React, { FC } from "react";
import { Flex, Icon, Modal } from "@telia/teddy";
import "./LoginHelpModal.less";

interface Props {
    open: boolean;
    onClose: () => void;
}

const LoginHelpModal: FC<Props> = ({ open, onClose }) => {
    return (
        <Modal open={open} onOpenChange={(next) => !next && onClose()}>
            <Modal.Overlay>
                <Modal.Content size="sm">
                    <Modal.Title as="h3">
                        <Flex align="center" gap="0.5rem">
                            <Icon name="end-user" aria-hidden="true" focusable="false" />
                            Innloggingshjelp
                        </Flex>
                    </Modal.Title>
                    <Modal.Close aria-label="lukk" slot="floating" onClick={onClose} />
                    <Modal.Group direction="column">
                        <p className="login-help-modal__text">
                            <span className="login-help-modal__label">Logg inn:</span> For å bruke denne
                            innloggingsmetoden er det viktig at brukeren din har lagt inn riktig e-postadresse. Du kan
                            sjekke dette i Salsa.
                        </p>
                        <br />
                        <p className="login-help-modal__text">
                            <span className="login-help-modal__label">Logg inn (m/SMS):</span> Skriv inn din
                            forhandlerkode og passord. Deretter vil du motta en SMS med engangskode til det mobilnummer
                            du oppgir.
                        </p>
                    </Modal.Group>
                </Modal.Content>
            </Modal.Overlay>
        </Modal>
    );
};

export default LoginHelpModal;
